import { COLLAPSE_SIDEBAR } from "../../constants/action.constants";

export const collapseSidebar = () => {
  return {
    type: COLLAPSE_SIDEBAR,
  };
};
